import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const schedule = {
  path: '/hospitalPatient',
  component: Layout,
  name: 'hospitalPatient',
  redirect: '/patientHistory/index',
  children: [
    {
      path: '/patientHistory/index',
      component: () => import('@/views/patientHistory/index'),
      name: 'patientHistory.index',
      meta: {
        title: i18n.t(`message.patient_histories`)
      }
    },
    {
      path: '/patientRoom/main/:id',
      component: () => import('@/views/patientRoom/index'),
      name: 'patientRooms',
      meta: {
        title: i18n.t(`message.patient_histories`)
      }
    },
  ]
}

export default schedule